import { Record } from 'immutable';
import * as ArticleQueryConstants from '../../constants/manage/LegacyArticleQueryConstants';
const LegacyArticlesQuery = Record({
  [ArticleQueryConstants.ARCHIVED_FIELD]: undefined,
  [ArticleQueryConstants.AUTHOR_FIELD]: undefined,
  [ArticleQueryConstants.KNOWLEDGE_CATEGORY_FIELD]: undefined,
  [ArticleQueryConstants.LANGUAGE_FIELD]: undefined,
  limit: 0,
  offset: 0,
  [ArticleQueryConstants.ORDER_FIELD]: undefined,
  [ArticleQueryConstants.SEARCH_FIELD]: undefined,
  [ArticleQueryConstants.STATE_FIELD]: undefined,
  [ArticleQueryConstants.VISIBILITY_FIELD]: undefined,
  [ArticleQueryConstants.VISIBILITY_LISTS_FIELD]: undefined,
  [ArticleQueryConstants.VISIBILITY_TYPE_FIELD]: undefined,
  contentGroupId: undefined,
  translated_from_id__is_null: '',
  knowledgeBaseId: undefined
});
export default LegacyArticlesQuery;